import { fallbackLng, parseLocale } from "../../i18n/settings";
import type { LocaleString } from "../../i18n/settings";

/**
 * URL pathname から locale を抽出する。
 *
 * - `/en/...` → `"en"`
 * - `/zh-cn/...` → `"zh-CN"`（URL は小文字慣習、内部表現は camelCase）
 * - prefix なし or 未対応 prefix（`/`, `/api`, `/zh-tw` 等） → `fallbackLng` (`"ja"`)
 *
 * Apollo Client の link で `x-language` ヘッダーをセットするために browser から呼ばれる純粋関数。
 * 内部で `i18n/settings.ts` の `parseLocale` を使い、FE 全体で対応 locale (`supportedLngs`) を統一する。
 */
export function extractLocaleFromPathname(pathname: string): LocaleString {
  const firstSegment = pathname.split("/").filter(Boolean)[0];
  if (!firstSegment) return fallbackLng;
  return parseLocale(firstSegment);
}
